import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { MaquinariaApiService } from 'src/app/service/api/tablas-maestras-api.service';
import { BaseForm } from 'src/app/view/base-form';
import { MaquinariaAlbaranModel } from 'src/app/models/ventas/tablas-maestras.model';
import { MaquinariaFormDefinition } from './form-control/form-definition';

@Component({
  selector: 'app-formulario-pulverizacion',
  standalone: false,
  templateUrl: './maquinaria-form.component.html',
  styleUrls: ['./maquinaria-form.component.scss'],
})
export class AlbaranesMaquinariaFormComponent extends BaseForm<MaquinariaAlbaranModel> implements OnInit {
  public form!: MaquinariaFormDefinition;
  public override model: MaquinariaAlbaranModel = {};

  public getRequest!: RequestHandler<MaquinariaAlbaranModel[]>;

  constructor(
    public override route: ActivatedRoute,
    public override dashboard: DashboardService,
    public override router: Router,
    public maquinariaApi: MaquinariaApiService,
  ) {
    super(
      route,
      router,
      dashboard,
      maquinariaApi.maquinariaPUT,
      maquinariaApi.maquinariaPOST,
      'albaran-maquinaria',
      'Actualizar Maquinaria',
      'Generar Maquinaria',
      'Duplicar Maquinaria',
    );

    this.getRequest = this.maquinariaApi.maquinariaGET;
  }

  public ngOnInit(): void {
    this.softInit(this.getType());
    this.form = new MaquinariaFormDefinition(this.getType(), this.model);
  }
}
